import { Form } from '~/shared/api'

export default class AgreementsSignaturesVersionsForm extends Form {
  versionIds: Array<string> = []
  email: string = ''
  phone: string = ''

  constructor(versionIds: Array<string>, email: string = '', phone: string = '') {
    super()
    this.versionIds = versionIds
    this.email = email
    this.phone = phone

    if (!this.email) {
      this.ignoreKeys = [...this.ignoreKeys, 'email']
    }
    if (!this.phone) {
      this.ignoreKeys = [...this.ignoreKeys, 'phone']
    }
  }
}
